import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, getToken } from "../../shared/utils.js/utils";
import i18n from "../../i18n/i18n";

// Get Vendors
export const getVendors = createAsyncThunk(
  "Vendors/getVendors",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (
        params.is_active !== undefined &&
        params.is_active !== null &&
        params.is_active !== ""
      ) {
        queryParams.append("is_active", params.is_active);
      }
      if (params.sort_by) queryParams.append("sort_by", params.sort_by);
      if (params.sort_direction)
        queryParams.append("sort_direction", params.sort_direction);
      const url = `${BASE_URL}/vendors${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to get vendors!";
      return rejectWithValue(message);
    }
  },
);

// Get Vendor Details
export const getVendorDetails = createAsyncThunk(
  "Vendors/getVendorDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/vendors/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get vendor details!";
      return rejectWithValue(message);
    }
  },
);

// Add Vendor
export const addVendor = createAsyncThunk(
  "Vendors/addVendor",
  async (data, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(`${BASE_URL}/vendors`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      let message = error.response?.data?.message || "Failed to add vendor!";
      if (error.response?.data?.errors) {
        message = Object.values(error.response.data.errors).flat().join(", ");
      }
      return rejectWithValue(message);
    }
  },
);

// update vendor
export const updateVendor = createAsyncThunk(
  "Vendors/updateVendor",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.put(`${BASE_URL}/vendors/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      let message = error.response?.data?.message || "Failed to update vendor!";
      if (error.response?.data?.errors) {
        message = Object.values(error.response.data.errors).flat().join(", ");
      }
      return rejectWithValue(message);
    }
  },
);

// Toggle Vendor Status
export const toggleVendorStatus = createAsyncThunk(
  "Vendors/toggleVendorStatus",
  async (arg, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      // Support both old format (id as number/string) and new format (object with id)
      const vendorId = typeof arg === "object" && arg !== null ? arg.id : arg;
      const response = await axios.patch(
        `${BASE_URL}/vendors/${vendorId}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": i18n.language,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to toggle vendor status!";
      return rejectWithValue(message);
    }
  },
);

// Delete Vendor
export const deleteVendor = createAsyncThunk(
  "Vendors/deleteVendor",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.delete(`${BASE_URL}/vendors/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to delete vendor!";
      return rejectWithValue(message);
    }
  },
);
